import { render, staticRenderFns } from "./ForceNewPassword.vue?vue&type=template&id=42e6ec5e&scoped=true"
import script from "./ForceNewPassword.vue?vue&type=script&lang=ts"
export * from "./ForceNewPassword.vue?vue&type=script&lang=ts"
import style0 from "./ForceNewPassword.vue?vue&type=style&index=0&id=42e6ec5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e6ec5e",
  null
  
)

export default component.exports